import {
  BoxStaffDetailedDto,
  BoxStaffItemDto,
  BoxStaffRole,
  BoxStaffStatus,
} from "@modules/boxStaff/gateway/boxStaffDto"
import { convertImageFromDto } from "@modules/dtos/imageDto"
import { ProfileTypeOf, User } from "@modules/profile/profileTypes"
import { convertPublicProfileFromDto } from "@modules/profile/publicProfile/publicProfileDto"
import { PublicProfile } from "@modules/profile/publicProfile/publicProfileTypes"
import { HUImage } from "@modules/types/imageTypes"
export type BoxStaffItemState = Omit<BoxStaffItemEntity, "convertToUser" | "getUserName">
export class BoxStaffItemEntity {
  id: string
  userId: string
  boxId: string
  role: BoxStaffRole
  status: BoxStaffStatus
  firstname: string
  lastname: string
  email: string
  avatar?: HUImage
  creationDate: Date
  username: string
  internalNote?: string
  archived: boolean

  private constructor(boxStaffItemEntity: BoxStaffItemState) {
    this.id = boxStaffItemEntity.id
    this.userId = boxStaffItemEntity.userId
    this.boxId = boxStaffItemEntity.boxId
    this.role = boxStaffItemEntity.role
    this.status = boxStaffItemEntity.status
    this.firstname = boxStaffItemEntity.firstname
    this.lastname = boxStaffItemEntity.lastname
    this.email = boxStaffItemEntity.email
    this.avatar = boxStaffItemEntity.avatar
    this.creationDate = boxStaffItemEntity.creationDate
    this.username = boxStaffItemEntity.username
    this.internalNote = boxStaffItemEntity.internalNote
    this.archived = boxStaffItemEntity.archived
  }

  static fromItemDto(dto: BoxStaffItemDto): BoxStaffItemEntity {
    return new BoxStaffItemEntity({
      id: dto.id,
      userId: dto.userId,
      boxId: dto.boxId,
      role: dto.role,
      status: dto.status,
      firstname: dto.firstname ?? "",
      lastname: dto.lastname ?? "",
      email: dto.email,
      avatar: dto.avatar ? convertImageFromDto(dto.avatar) : undefined,
      creationDate: new Date(dto.creationDate),
      username: dto.username,
      internalNote: dto.internalNote ?? "",
      archived: dto.archived,
    })
  }

  getUserName(): string {
    if (this.username === "") {
      return this.username
    }
    return "@" + this.username
  }

  convertToUser(): User {
    return {
      id: this.userId,
      _type: ProfileTypeOf,
      firstname: this.firstname,
      lastname: this.lastname,
      username: this.username,
      avatar: this.avatar,
    }
  }
}

export class BoxStaffDetailedEntity {
  id: string
  userId: string
  boxId: string
  role: BoxStaffRole
  status: BoxStaffStatus
  firstname: string
  lastname: string
  email: string
  avatar?: HUImage
  creationDate: Date
  username: string
  internalNote?: string
  archived: boolean
  publicProfile?: PublicProfile

  private constructor(boxStaffDetailed: BoxStaffDetailedEntity) {
    this.id = boxStaffDetailed.id
    this.userId = boxStaffDetailed.userId
    this.boxId = boxStaffDetailed.boxId
    this.role = boxStaffDetailed.role
    this.status = boxStaffDetailed.status
    this.firstname = boxStaffDetailed.firstname
    this.lastname = boxStaffDetailed.lastname
    this.email = boxStaffDetailed.email
    this.avatar = boxStaffDetailed.avatar
    this.creationDate = boxStaffDetailed.creationDate
    this.username = boxStaffDetailed.username
    this.internalNote = boxStaffDetailed.internalNote
    this.archived = boxStaffDetailed.archived
    this.publicProfile = boxStaffDetailed.publicProfile
  }

  static fromDetailedDto(dto: BoxStaffDetailedDto): BoxStaffDetailedEntity {
    return new BoxStaffDetailedEntity({
      id: dto.id,
      userId: dto.userId,
      boxId: dto.boxId,
      role: dto.role,
      status: dto.status,
      firstname: dto.firstname ?? "",
      lastname: dto.lastname ?? "",
      email: dto.email,
      avatar: dto.avatar ? convertImageFromDto(dto.avatar) : undefined,
      creationDate: new Date(dto.creationDate),
      username: dto.username,
      internalNote: dto.internalNote ?? "",
      archived: dto.archived,
      publicProfile: dto.publicProfile ? convertPublicProfileFromDto(dto.publicProfile) : undefined,
    })
  }
}
